import styled from '@emotion/styled';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { ChangeEvent, memo } from 'react';
import { COLOR_BORDER, COLOR_EFFECT, COLOR_TEXT_MAIN } from '../../../theme/colors';

const _SelectBox = ({
  title,
  option,
  value,
  setValue,
  isLoading = false,
  position,
}: {
  title: string;
  option: { label: string; value: string }[];
  value: string;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  isLoading: boolean;
  position?: 'absolute';
}) => {
  return (
    <SelectBoxWithTitleWrapper position={position}>
      <div>{title}</div>
      <FormControlMui variant="standard">
        <SelectMui
          disabled={isLoading}
          onChange={(
            e: ChangeEvent<{
              name?: string | undefined;
              value: unknown;
            }>,
          ) => {
            setValue((e.target.value ?? value) as string);
          }}
          value={value}
        >
          {option.map(({ label, value }: { label: string; value: string }) => {
            return (
              <MenuItem value={value} key={`option_${value}`}>
                {label}
              </MenuItem>
            );
          })}
        </SelectMui>
      </FormControlMui>
    </SelectBoxWithTitleWrapper>
  );
};

export const SelectBox = memo(_SelectBox);

const SelectBoxWithTitleWrapper = styled('div')<{ position?: string }>(
  (props) => `
  display: inline-block;
  margin-right: 24px;
  :last-child {
    margin-right: 0;
  } 
  position: ${props.position === 'absolute' ? 'absolute' : 'inherit'};
  right: ${props.position === 'absolute' ? '0' : 'unset'};
  top: ${props.position === 'absolute' ? '-18px' : 'unset'};
  width: ${props.position === 'absolute' ? '158px' : 'calc(33% - 16px)'};
  `,
);

const FormControlMui = styled(FormControl)(`
    border: 1.5px solid ${COLOR_BORDER};
    border-radius: 4px;
    height: 40px;
    width: 100%;
    margin-top: 8px;
    .MuiInput-underline:after,.MuiInput-underline:before,.MuiInput-underline:hover:not(.Mui-disabled):before {
      border: none;
    }
`);

const SelectMui = styled(Select)(`
  background-color: white;
  color: ${COLOR_TEXT_MAIN};
  font-size: 12px;
  font-weight: 700;
  height: 40px;
  outline: none;
  padding-left: 12px;
  fieldset {
    border: 1.5px solid ${COLOR_BORDER};
    &:focus-visible {
      border: none;
    }
    &:focus {
      outline: none;
    }
  }
  &:hover:not(.Mui-disabled) {
    color: ${COLOR_EFFECT};
    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLOR_BORDER};
    }
  }
  .MuiSelect-root {
    background-color: transparent;
  }
`);
